/**
 * @generated SignedSource<<4dbedf204ae66a5c3ac65dd6f07efb14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewData_widgetIssueOverview$data = {
  readonly id: string;
  readonly issues: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewList_issue">;
  }>;
  readonly overviewSize: WidgetOverviewSize;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetIssueOverviewData_widgetIssueOverview";
};
export type WidgetIssueOverviewData_widgetIssueOverview$key = {
  readonly " $data"?: WidgetIssueOverviewData_widgetIssueOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewData_widgetIssueOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewData_widgetIssueOverview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "issues",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIssueOverviewList_issue"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIssueOverview",
  "abstractKey": null
};
})();

(node as any).hash = "0494878159830d8ecf251a60b57c71d4";

export default node;
